<template>
  <div class="page-wrap">
    <section>
          <div class="image-containers">
      <van-swipe :autoplay="3000">
        <van-swipe-item v-for="(image, index) in images" :key="index" class="thumbnail">
          <img :src="image" />
        </van-swipe-item>
      </van-swipe>
    </div>
    </section>
    <section class="service-panel-list">
      <van-cell-group>
        <van-cell title="我的服务" is-link to="/service-orders/0"> </van-cell>
      </van-cell-group>
        <van-row class="service-list">
          <router-link to="/service-orders/1">
          <van-col span="8" style="border-right:none;" >
            <i class="van-icon"><img src="../assets/images/待付款.png" alt=""></i><span>待支付({{items.pendingCount}})</span>
          </van-col>
          </router-link>
          <router-link to="/service-orders/2">
          <van-col span="8" style="border-right:none;">
            <i class="van-icon"><img src="../assets/images/订单-处理中.png" alt=""></i><span>处理中({{items.processingCount}})</span>
          </van-col>
          </router-link>
          <router-link to="/service-orders/3">
          <van-col span="8" style="border-right:none;">
            <i class="van-icon"><img src="../assets/images/evaluate.png" alt=""></i><span>待评价({{items.completedCount}})</span>
          </van-col>
          </router-link>
        </van-row>
    </section>

    <section class="service-panel-list ">
      <van-cell-group>
        <van-cell title="社保服务"></van-cell>
      </van-cell-group>
        <van-row class="service-list">
          <router-link :to="`/service/${item.id}`" v-for="item in items.serviceTypes" v-if="item.biz_type === 'shebao'" :key="item.id" >
            <van-col span="8" class="van-hairline--right van-hairline--bottom" v-bind:class="item.fee === 0 ? 'free' : ''">
              <i class="van-icon"><img :src="item.icon" alt="icon"></i><span>{{item.name}}</span>
            </van-col>
          </router-link>
        </van-row>
    </section>


    <section class="service-panel-list">
      <van-cell-group>
        <van-cell title="代办服务"></van-cell>
      </van-cell-group>
        <van-row class="service-list">
          <router-link :to="`/service/${item.id}`" v-for="(item) in items.serviceTypes" :key="item.id" v-if="item.biz_type === 'agency'" >
            <van-col span="8" class="van-hairline--right van-hairline--bottom" v-bind:class="item.fee === 0 ? 'free' : ''">
              <i class="van-icon"><img :src="item.icon" alt="icon"></i><span>{{item.name}}</span>
            </van-col>
          </router-link>
        </van-row>
    </section>

  </div>
</template>

<script>
import {
  NavBar,
  Button,
  Row,
  Col,
  Field,
  CellGroup,
  Toast,
  Checkbox,
  CheckboxGroup,
  Cell,
  Swipe,
  SwipeItem
} from "vant";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Cell.name]: Cell
  },
  props: ["message"],
  name: "services",
  data: function() {
    return {
      items: [],
      images: [
        require("../assets/images/banners/servcie-banner1.jpg"),
        require("../assets/images/banners/servcie-banner2.jpg"),
        require("../assets/images/banners/servcie-banner3.jpg")
      ]
    };
  },
  mounted: function() {
      this.queryServiceTypes()
  },
  methods: {
    queryServiceTypes() {
      this.$http.get('/api/service_type/list').then(response => {
        this.items = response.data.data
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "../assets/less/var.less";
.service-panel-list {
  margin-top: 9px;
  background-color: white;
  h2 {
    margin: 0;
    font-size: 14px;
    color: @defaultDescColor;
    padding: 15px 15px;
  }
  clear: both;
}
.banner-swipe {
  div {
    line-height: 0;
  }
  img {
    width: 100%;
  }
}

</style>


<style lang="less" >
@import "../assets/less/var.less";
.service-panel-list {
  [class*=van-hairline]::after {
    border-color: #d8d8d8;
  }
  .van-col {
    text-align: center;
    height: 90px;
    vertical-align: middle;

    &.free {
      background: url("../assets/images/free.png") no-repeat;
      background-size: 30px;
    }

    &:last-child {
    }

    span {
      font-size: 13px;
      color: @defaultDescColor;
    }
  }

  .van-row {

  }

  .service-list {
    .van-icon {
      display: block;
      font-size: 32px;
      margin: 10px 0;
      img {
        width: 25px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/services.vue